import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, Button, CircularProgress } from '@mui/material'

const SubmitButton = ({ buttonLabel, loadingLabel, textAlign = 'center', disabled = false }) => {
  const { formState: { isSubmitting, isValid } } = useFormContext()
  return (
    <Box sx={{ m: 1, position: 'relative', textAlign }}>
      <Button disabled={isSubmitting || !isValid || disabled} type="submit">
        {isSubmitting ? (loadingLabel || 'Submitting...') : (buttonLabel || 'Submit')}
      </Button>
      { isSubmitting && <CircularProgress size={24} sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-12px',
        marginLeft: '-12px'
      }} /> }
    </Box>
  )
}

export default SubmitButton
